export class MenuCheckbox extends Phaser.GameObjects.Container {
    constructor(scene, x, y, options = {}) {
        super(scene, x, y);
        
        const {
            initialValue = false,
            onChange = () => {},
            label = ''
        } = options;
        
        this.isChecked = initialValue;
        this.onChange = onChange;
        this.label = label;
 
        scene.load.image('checkboxChecked', '/sprites/ui/Menu/checkboxChecked.png');
        scene.load.image('checkboxUnchecked', '/sprites/ui/Menu/checkboxUnchecked.png');
        scene.load.once('complete', () => {
            this.buildCheckbox(scene);
        });
        scene.load.start();
    }
 
    buildCheckbox(scene) {
        if (this.label) {
            this.labelText = scene.add.text(0, -14, this.label, { 
                fontSize: '12px',
                color: '#000000'
            });
            this.add(this.labelText);
        }
 
        this.checkbox = scene.add.sprite(0, 0, this.isChecked ? 'checkboxChecked' : 'checkboxUnchecked');
        this.checkbox.setOrigin(0);
        this.checkbox.setInteractive();
        this.setupInteraction();
        
        this.add(this.checkbox);
        scene.add.existing(this);
    }
 
    setupInteraction() {
        this.checkbox.on('pointerdown', () => {
            this.isChecked = !this.isChecked;
            this.checkbox.setTexture(this.isChecked ? 'checkboxChecked' : 'checkboxUnchecked');
            this.onChange(this.isChecked);
        });
    }
 
    setValue(value) {
        this.isChecked = value;
        if (this.checkbox) {
            this.checkbox.setTexture(value ? 'checkboxChecked' : 'checkboxUnchecked');
        }
    }
 
    getValue() {
        return this.isChecked;
    }
 }


 // USAGE
//  const muteCheckbox = new MenuCheckbox(this, PADDING + 15, PADDING + 80, {
//     label: 'Mute Audio',
//     initialValue: false,
//     onChange: (value) => {
//         this.sound.mute = value;
//     }
// });